/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-09-06 10:33:40
 */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { DtMessageService } from '@ithinkdt/shared/message';
import { cloneDeep } from 'lodash';
import { ControlValueAccessorService } from '../../control-value-accessor.service';
import { FormSearchService } from '../../fetch/form-fetch.service';
import { FORM_CONSTANTS } from '../../form-constant';
import monitor from '../../monitor';

@Component({
  selector: 'dt-form-card-upload',
  templateUrl: './form-card-upload.component.html',
  styleUrls: ['./form-card-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormCardUploadComponent),
      multi: true,
    },
  ],
})
export class FormCardUploadComponent extends ControlValueAccessorService implements OnInit, OnDestroy, OnChanges {
  // {"status":true,"code":"0000","messages":"",
  // "data":[{"id":null,"createDate":"1590389534635","createUser":"system","updateDate":null,"updateUser":"system","fileId":"5ecb6b1e1c52d9000bb0ac9a","fileName":"1588040988(1).png","fileSize":57592,"contentType":"png","type":"ATTACHMENT","delete":false,"endCreateDate":null,"description":null,"createUserName":null,"createPersonName":null,"path":"/ATTACHMENT/20200525/5ecb6b1e1c52d9000bb0ac9b.png","businessId":null}],"page":0,"record":0,"total":0}
  // æ§ä»¶ç±»å
  value: any;
  @Input() formControlName: string;
  @Input() type = 'buttonModal';
  // æ¥åä¸ä¼ çæä»¶ç±»å  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-accept   https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
  @Input() acceptType = 'image/png,image/jpeg,image/gif,image/bmp';
  @Input() prop = '';
  // ç¦æ­¢ä¸ä¼ çæä»¶ç±»åï¼ä¾å¦ï¼image/png,image/jpeg,image/gif,image/bmp
  @Input() banType = 'image/png,image/jpeg,image/gif,image/bmp';
  // ä¸ä¼ æä»¶è¯·æ±çapi
  @Input() reqUrl = '/api/v1/ithinkdt-file/pub/bus/file/upload.do';
  @Input() downloadUrl = '/api/v1/ithinkdt-file/pub/bus/file/download.do?fileId='; // ä¸è½½
  @Input() imgPreviewUrl = '/api/v1/ithinkdt-file/pub/bus/file/image?fileId='; // å¾çé¢è§
  // æ¥åä¸ä¼ çæä»¶å¤§å°ï¼åä½kb,é»è®¤10M
  @Input() size = 1024 * 1024 * 10;
  // ä¸ä¼ åè¡¨çåå»ºæ ·å¼ï¼æ¯æä¸ç§åºæ¬æ ·å¼ text, picture å picture-card
  @Input() nzListType = 'picture';
  // ä¸ä¼ åè¡¨çæ ·å¼ï¼æ¯æä¸ç§åºæ¬æ ·å¼ text, picture å picture-card
  @Input() showType = 'picture';
  // æ¯å¦æ¯æå¤ä¸ªä¸ä¼ 
  @Input() multiple = true;
  // æ¯å¦ç¦ç¨
  @Input() disabled = false;

  // æ¨¡ææ¡æ é¢
  @Input() title = 'fileUpload.upload';
  // æ¯å¦æ¾ç¤ºæé®ï¼ä¸ç¶åªæ¾ç¤ºå¾æ 
  @Input() showBtn = false;
  // æé®åç§°
  @Input() btnName = 'fileUpload.upload';
  // åªæ¾ç¤ºå¾æ æ¶å¾æ æ ·å¼:{'color': '#0061aa'}
  @Input() onlyIconStyle: object;
  // è¥ä¸æ³ç¨æé®ä¹ä¸æ³ç¨å¾æ èªå®ä¹æé®ï¼åè®¾ç½®æ­¤é¡¹ä¸ºtrue
  @Input() customContent = false;
  // æç¤ºæå­
  @Input() tips = 'fileUpload.supportDocuments';
  // å¾çä¸åè®¸éå¤ï¼è¥æéå¤çåå é¤
  @Input() deleteUniqFile = false;
  // æ¯æä¸ä¼ æä»¶å¤¹
  @Input() nzDirectory = false;
  // éå¶åæ¶ä¸ä¼ æä»¶æ°ï¼é»è®¤ä¸éå¶
  @Input() nzLimit = 10;
  @Input() needToken = true;
  @Input() onBeforeUpload: any;
  @Input() setParentValue: (conf, value) => void;
  @Input() conf: any;
  @Input() set files(files: any[]) {
    if (Array.isArray(files)) {
      this.fileList = files;
      this.stagingData = this.setFiles(files);
    }
  }
  stagingData = [];
  fileList = [];
  readOnly = false;
  previewIndex = 0;
  @Output() valueChange = new EventEmitter<any>();
  // é¢è§
  previewVisible = false;
  // é¢è§å¾ç
  previewImage: string;
  constructor(
    private settingsSrv: SettingsService,
    private msgSrv: DtMessageService,
    private i18n: I18NService,
    private formSearchSrv: FormSearchService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }
  writeValue(value) {
    this.value = value;
    if (Array.isArray(value)) {
      this.fileList = value;
      this.stagingData = this.setFiles(value);
    }
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    }
    this._changeValue(value);
  }
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.isDisabled = isDisabled;
  }

  ngOnInit() {
    this.changeValueCallback(this.changeValue);
  }
  ngOnDestroy(): void {
    // monitor.off('setPropValueOf' + this.prop);
  }
  ngOnChanges(changes): void {
    if (changes.prop && changes.prop.currentValue) {
      this.acceptType = this.acceptType || 'image/png,image/jpeg,,image/jpg,image/gif,image/bmp';
      this.changeDetectorRef.detectChanges();
    }
  }
  changeValue = (value) => {
    if (Array.isArray(value)) {
      this.stagingData = this.setFiles(value);
    }
  };
  setFiles(list: any[]) {
    return list.map((i) => this.handleViewUrl(i));
  }
  beforeUpload = (file): boolean => {
    // å¦æè®¾ç½®äºä¸ä¼ ç±»å å¹¶ä¸ç±»åéè¯¯çè¯ æä¼æ¥é
    if (!!this.acceptType && this.acceptType.indexOf(file.type) === -1 && this.acceptType !== '.') {
      this.msgSrv.warning('fileUpload.typeError');
      return false;
    }
    // æä»¶è¿å¤§
    if (file.size > this.size) {
      this.msgSrv.warning('fileUpload.sizeOver');
      return false;
    }
    if (this.fileList.length >= this.nzLimit) {
      this.msgSrv.warning('fileUpload.limitSize');
      return false;
    }
    // è¥ä¸åè®¸éå¤ï¼åå¤æ­å½åæ¯å¦å·²ä¸ä¼ ï¼æªä¸ä¼ åæ·»å 
    // if (this.deleteUniqFile) {
    //   const canContact = !this.stagingData.some((item) => {
    //     return item.filename === file.filename && item.size === file.size && item.lastModified === file.lastModified;
    //   });
    //   if (canContact) {
    //     this.stagingData = this.stagingData.slice(0, -1);
    //     this.fileList = this.fileList.slice(0, -1);
    //   }
    // }

    let isUpload = true;
    if (this.onBeforeUpload) {
      const fileObj = Object.assign(file, { propName: this.prop });
      isUpload = this.onBeforeUpload(fileObj);
    }

    if (isUpload) {
      this.upload(this.handleViewUrl(file));
    }
    return false;
  };
  upload(file) {
    if (!file) {
      this.msgSrv.warning('fileUpload.tips');
      return;
    }
    this.readOnly = true;
    this.formSearchSrv.uploadData(this.reqUrl, [file]).subscribe((res) => {
      if (res.status && res.data && res.data[0]) {
        this.msgSrv.success('fileUpload.uploadSuccess');
        const _file = {
          fileId: res.data[0].fileId,
          fileName: res.data[0].fileName,
        };
        const stagingData = [...this.stagingData, this.handleViewUrl(_file)];
        this.fileList = [...this.fileList, _file];
        if (this.nzLimit) {
          this.stagingData = stagingData.slice(-this.nzLimit);
          this.fileList = this.fileList.slice(-this.nzLimit);
        }
        this.writeValue(this.fileList);
        this.updateChanges();
        if (this.setParentValue) {
          this.setParentValue(this.conf, this.value);
        }
        this.valueChange.emit(this.value);
      }
      this.readOnly = false;
    });
  }

  // å¤çé¡µé¢å±ç¤ºå¾ççè·¯å¾
  handleViewUrl(item) {
    const file = this.settingsSrv.userConfig['env'].serverName.file;
    if (item.fileId && item.fileId.search(file) === -1) {
      const token = this.settingsSrv.token;
      const urlNoToken = FORM_CONSTANTS.imgDown;
      const urlToken = FORM_CONSTANTS.showImage;
      item = cloneDeep(item);
      item.fileId = `${file}${urlNoToken}${item.fileId}`;
      // if (this.needToken) {
      //   item.fileId = `${file}${urlToken}${token}&fileId=${item.fileId}`;
      // } else {
      //   item.fileId = `${file}${urlNoToken}${item.fileId}`;
      // }
    }
    return item;
  }

  // å é¤äºä»¶
  removeUpload(item) {
    const arr = [];
    this.stagingData.map((t) => {
      if (t.fileId !== item.fileId) {
        arr.push(t);
      }
    });
    this.fileList = this.fileList.filter((i) => item.fileId.search(i.fileId) === -1);
    this.stagingData = arr;
    this.writeValue(this.fileList);
    this.updateChanges();
    if (this.setParentValue) {
      this.setParentValue(this.conf, this.fileList);
    }
    this.valueChange.emit(this.value);
  }

  // é¢è§æä½
  openPreview(index) {
    this.previewIndex = index;
    this.previewVisible = true;
    this.previewImage = this.stagingData[index].fileId;
  }
  close() {
    this.previewVisible = false;
  }
}
